// extracted by mini-css-extract-plugin
module.exports = {"quantity":"TreatmentUnavailable_quantity__ILlcO","totals":"TreatmentUnavailable_totals__VoBKP"};